const _BUTTON_TYPES = {
    ADD: {messageId: 'buttons.add'},
    ARCHIVE: {messageId: 'buttons.archive'},
    DELETE: {messageId: 'buttons.delete'},
    EDIT: {messageId: 'buttons.edit'},
    RESTORE: {messageId: 'buttons.restore'},
    UNARCHIVE: {messageId: 'buttons.unarchive'}
};


export const BUTTON_TYPES = Object.keys(_BUTTON_TYPES).reduce((acc, key) => {
    acc[key] = {..._BUTTON_TYPES[key], key: key.toLowerCase()};
    return acc;
}, {});


// WEBPACK FOOTER //
// ./src/constants/dialogButtonTypes.js